import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getSelection, $isRangeSelection } from 'lexical'
import { TOGGLE_LINK_COMMAND } from '@lexical/link'
import { Menu } from '../../Menu/index.js'
import { useState } from 'react'

export const InsertLink = ({ isLink, disabled, size }) => {
  const [editor] = useLexicalComposerContext()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <Menu onOpen={() => setMenuOpen(true)} onClose={() => setMenuOpen(false)}>
      <Menu.Trigger>
        <IconButton
          tooltip={menuOpen ? null : 'Insert link'}
          keyHint={menuOpen ? null : 'Cmd+K'}
          keyHintVisualOnly
          size={size}
          icon="link-on"
          trailChevron="down"
          toggled={isLink}
          disabled={disabled}
        />
      </Menu.Trigger>
      <Menu.Items>
        <Menu.Item
          visualOnlyKeyHint="Cmd+K"
          leadIcon="link-on"
          onClick={() =>
            editor.update(() => {
              const selection = $getSelection()

              if ($isRangeSelection(selection) && selection.isCollapsed()) {
                return
              } else if (
                $isRangeSelection(selection) &&
                selection.getTextContent() === ' '
              ) {
                return
              }

              editor.dispatchCommand(TOGGLE_LINK_COMMAND, isLink ? null : '')
            })
          }
        >
          Add link
        </Menu.Item>
        <Menu.Item leadIcon="external">Link to reference</Menu.Item>
      </Menu.Items>
    </Menu>
  )
}
